import axios from "src/lib/axios"

const getPackageList = () => {
  return axios.get("/api/v1/package/getPackageList")
}

const clubInsertUserPackage = packageId => {
  return axios.post("/api/v1/package/insertUserPackage", { packageId })
}

const clubServices = { getPackageList, clubInsertUserPackage }

export default clubServices
